import { Injectable } from '@angular/core';

import { CollaborationDeepLinkState } from '../models/collaboration-deep-link-state.interface';

export { CollaborationDeepLinkState } from '../models/collaboration-deep-link-state.interface';

export const COLLAB_COMPANY_ID_KEY = 'collab_company_id';
const COLLAB_COMPANY_NAME_KEY = 'collab_company_name';
const COLLAB_EMAIL_KEY = 'collab_collaborator_email';
const COLLAB_ASSESSMENT_ID_KEY = 'collab_assessment_id';
const COLLAB_ERROR_KEY = 'collab_error';
const COLLAB_DEEP_LINK_STATE_KEY = 'collab_deep_link_state';

interface CollaborationErrorState {
    error: string;
    status?: number;
}

@Injectable({
    providedIn: 'root',
})
export class CollaborationTokenStoreService {

    getCompanyId(): string | undefined {
        return localStorage.getItem(COLLAB_COMPANY_ID_KEY) ?? undefined;
    }

    setCompanyId(companyId: string): void {
        localStorage.setItem(COLLAB_COMPANY_ID_KEY, companyId);
    }

    getCompanyName(): string | undefined {
        return localStorage.getItem(COLLAB_COMPANY_NAME_KEY) ?? undefined;
    }

    setCompanyName(companyName: string): void {
        localStorage.setItem(COLLAB_COMPANY_NAME_KEY, companyName);
    }

    getCollaboratorEmail(): string | undefined {
        return localStorage.getItem(COLLAB_EMAIL_KEY) ?? undefined;
    }

    setCollaboratorEmail(email: string): void {
        localStorage.setItem(COLLAB_EMAIL_KEY, email);
    }

    getActiveAssessmentId(): string | undefined {
        return localStorage.getItem(COLLAB_ASSESSMENT_ID_KEY) ?? undefined;
    }

    setActiveAssessmentId(assessmentId: string): void {
        localStorage.setItem(COLLAB_ASSESSMENT_ID_KEY, assessmentId);
    }

    clearActiveAssessmentId(): void {
        localStorage.removeItem(COLLAB_ASSESSMENT_ID_KEY);
    }

    getCollaborationErrorState(): { error: string; status?: number } {
        const raw = localStorage.getItem(COLLAB_ERROR_KEY);
        return raw ? JSON.parse(raw) as CollaborationErrorState : { error: '' };
    }

    setCollaborationErrorState(error: string, status?: number): void {
        localStorage.setItem(COLLAB_ERROR_KEY, JSON.stringify({ error, status }));
    }

    clearCollaborationErrorState(): void {
        localStorage.removeItem(COLLAB_ERROR_KEY);
    }

    getDeepLinkState(): CollaborationDeepLinkState | null {
        const raw = localStorage.getItem(COLLAB_DEEP_LINK_STATE_KEY);
        if (!raw) return null;
        try {
            return JSON.parse(raw) as CollaborationDeepLinkState;
        } catch {
            return null;
        }
    }

    setDeepLinkState(state: CollaborationDeepLinkState): void {
        localStorage.setItem(COLLAB_DEEP_LINK_STATE_KEY, JSON.stringify(state));
    }

    clearDeepLinkState(): void {
        localStorage.removeItem(COLLAB_DEEP_LINK_STATE_KEY);
    }

    clearAll(): void {
        localStorage.removeItem(COLLAB_COMPANY_ID_KEY);
        localStorage.removeItem(COLLAB_COMPANY_NAME_KEY);
        localStorage.removeItem(COLLAB_EMAIL_KEY);
        localStorage.removeItem(COLLAB_ASSESSMENT_ID_KEY);
        localStorage.removeItem(COLLAB_ERROR_KEY);
        localStorage.removeItem(COLLAB_DEEP_LINK_STATE_KEY);
    }
}
